// extracted by mini-css-extract-plugin
export default {"cardsGroup":"Team_cardsGroup__zZ7K6"};